import { Command } from 'commands/Commands';

export class ChangeLeadBroker extends Command {
  priority: number = 100;
  type: string = 'ChangeLeadBroker';
}
